import { render, staticRenderFns } from "./CollectionCardContent.vue?vue&type=template&id=46eb35c8&"
import script from "./CollectionCardContent.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports